import { ModalId } from '../../../../enums/modalId'

export { EInvoiceApprovalConfirmationModal } from './EInvoiceApprovalConfirmationModal'

export const eInvoiceApprovalConfirmationModalId = ModalId.EInvoiceApprovalConfirmationModal
